import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTeleconsultingContext } from 'contexts/TeleconsultingContext';
import i18n from 'i18n';
import React from 'react';
import { formatName } from 'utils/AuxiliarFunctions';
import {
  formatISO2DisplayDateString,
  formatISO2DisplayTimeString,
} from 'utils/dateFunctions';

import './NotificationsCard.css';

export function NotificationsCard({ data }) {
  const { compareDates } = useTeleconsultingContext();

  return (
    <div className="notificationCard">
      {compareDates(data?.resource?.start) ? (
        <a href={data.resource.comment} target="_blank" rel="noreferrer">
          <div className="notificationCardContent">
            <div className="notificationCard-firstLine">
              {compareDates(data?.resource?.start) && (
                <FontAwesomeIcon icon={faCircle} />
              )}

              <p className="notification-title">
                {data?.resource?.appointmentType.text}
              </p>
              <p className="notification-rightText"> HU </p>
            </div>
            <div className="notificationCard-time">
              <p className="notificationCard-timeText">
                {formatISO2DisplayTimeString(
                  data?.resource?.start,
                  i18n.language,
                ).slice(0, -3)}
              </p>
            </div>
            <div className="notificationCard-profissional">
              <p className="notificationCard-profissionalText">
                Profissional:{' '}
                {formatName(
                  data.resource.contained.find(
                    (auxParticipant) => auxParticipant.id === 'practitioner1',
                  )?.name[0]?.text || 'Indisponível',
                )}
              </p>
            </div>
          </div>
        </a>
      ) : (
        <div className="notificationCardContent">
          <div className="notificationCard-firstLine">
            {compareDates(data?.resource?.start) && (
              <FontAwesomeIcon icon={faCircle} />
            )}

            <p className="notification-title">
              {data?.resource?.appointmentType.text}
            </p>
            <p className="notification-rightText"> HU </p>
          </div>
          <div className="notificationCard-time">
            <p className="notificationCard-timeText">
              {formatISO2DisplayDateString(
                data?.resource?.start,
                i18n.language,
              )}{' '}
              |{' '}
              {formatISO2DisplayTimeString(
                data?.resource?.start,
                i18n.language,
              ).slice(0, -3)}
            </p>
          </div>
          <div className="notificationCard-profissional">
            <p className="notificationCard-profissionalText">
              Profissional:{' '}
              {formatName(
                data.resource.contained.find(
                  (auxParticipant) => auxParticipant.id === 'practitioner1',
                )?.name[0]?.text || 'Indisponível',
              )}
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
